var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.7832,
    cy: 18.7832,
    r: 18.7832,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7832 27.7812V25.7812C26.7832 24.7204 26.3618 23.703 25.6116 22.9528C24.8615 22.2027 23.8441 21.7813 22.7832 21.7812H14.7832C13.7223 21.7812 12.7049 22.2027 11.9548 22.9528C11.2046 23.703 10.7832 24.7204 10.7832 25.7812V27.7812",
    stroke: "#0066CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 17.7812C20.9923 17.7812 22.7832 15.9904 22.7832 13.7812C22.7832 11.5721 20.9923 9.78125 18.7832 9.78125C16.5741 9.78125 14.7832 11.5721 14.7832 13.7812C14.7832 15.9904 16.5741 17.7812 18.7832 17.7812Z",
    stroke: "#0066CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutProfileIcon);
export default __webpack_public_path__ + "static/media/logoutProfileIcon.2b6e76fb576c92903dbd47e51b2c772f.svg";
export { ForwardRef as ReactComponent };